export default "__VITE_ASSET__DXCyHXER__"